export const ACCESS_TOKEN_KEY = 'access_token_key';
export const REFRESH_TOKEN_KEY = 'refresh_token_key';
export const ACCESS_COR_ID_TOKEN_KEY = 'access_corId_token_key';
export const REFRESH_COR_ID_TOKEN_KEY = 'refresh_corId_token_key';
export const LANG_CODE_KEY = 'lang_code_key';
